var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCondolence = function SvgCondolence(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-1-1h802v602H-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "M91.25 34.6786H52.4265V.8466h-4.853v33.832H8.75v4.853h38.8235v59.6218h4.853V39.5315H91.25v-4.853z"
  })));
};
export default SvgCondolence;